import AOS from 'aos';
import 'aos/dist/aos.css';

export default () => {
	const elms = document.querySelectorAll('.aos-default-elm');
	elms.forEach(elm => {
		elm.dataset.aos = 'fade-up';
	});

	const elms2 = document.querySelectorAll('.wp-block-columns .wp-block-column');
	elms2.forEach(elm => {
		elm.dataset.aos = 'fade-up';
	});

	AOS.init({
		once: true,
		delay: 100,
	});
}